import React from "react";
import { Box, Paper, Typography, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";

const DemoEnded = () => {
  const navigate = useNavigate();

  return (
    <Box
      display="flex"
      justifyContent="center"
      alignItems="center"
      minHeight="100vh"
      sx={{ backgroundColor: "#f5f5f5", p: 2 }}
    >
      <Paper elevation={3} sx={{ p: 4, width: "100%", maxWidth: 500, textAlign: "center" }}>
        <Typography variant="h5" gutterBottom>
          ❌ Session has ended
        </Typography>
        <Typography variant="body1" gutterBottom>
          The QR code you scanned is no longer active. Please scan the latest barcode to continue.
        </Typography>
        <Button
          variant="contained"
          sx={{ mt: 2 }}
          onClick={() => navigate("/extended-sidebar/demo")}
        >
          Back to Demo
        </Button>
      </Paper>
    </Box>
  );
};

export default DemoEnded;
